export const DISCOUNTS_BY_PROPERTY_VALUE = 'discountsByProperty';
export const APARTMENTS_VALUE = 'apartments';
